import { render } from "./ModuleInfoModal.vue?vue&type=template&id=a5e1e17a&scoped=true"
import script from "./ModuleInfoModal.vue?vue&type=script&lang=js"
export * from "./ModuleInfoModal.vue?vue&type=script&lang=js"

import "./ModuleInfoModal.vue?vue&type=style&index=0&id=a5e1e17a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e1e17a"]])

export default __exports__